<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="p01">
<h1 class="part"><a id="page1"></a>PART<br/>ONE</h1>
<p class="img"><img alt="" height="51" src="OEBPS/9780312352080_003.jpg" width="50"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312352080_epub_p01_r1.vue?606976ae